import { ReferenceTableData, ReferenceTableQuery } from 'chaika-frontend-types/frontend-cms';

import { LongList } from '@store/abstract/LongList';

export interface LaboratoryReferenceTableFilter extends ReferenceTableQuery {}

export class LaboratoryReferenceTableList extends LongList<
    ReferenceTableData,
    ReferenceTableData,
    LaboratoryReferenceTableFilter
> {
    public static Name = 'laboratoryReferenceTableList' as const;

    protected create(params: ReferenceTableData): ReferenceTableData {
        return params;
    }

    protected filterValue(value: ReferenceTableData, { id }: LaboratoryReferenceTableFilter) {
        return this.filterFieldValueByArray(value, id, 'id');
    }
}
